import script from "./WorkflowAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAdd.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAdd.vue?vue&type=style&index=0&id=8cd6293e&lang=css"

const __exports__ = script;

export default __exports__